/**
 * Copyright 2025 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */

import PropTypes from 'prop-types';
import MediaSourceSelector from './MediaSourceSelector';
import VideoContainer from '../containers/VideoContainer';
import AudioContainer from '../containers/AudioContainer';
import styles from '../styles/gumConfiguration.css';

const GUMConfigurationView = ({
  propsStyle,
  classNames,
  videoOnly,
  audioOnly,
  audioSources,
  videoSources,
  includeScreen,
  confirmDevices,
  confirmButtonText,
  confirmButtonDisabled,
  audioMediaStream,
  videoMediaStream,
  selectedAudioSource,
  selectedVideoSource,
  onVideoSourceSelect,
  onAudioSourceSelect
}) => {
  const confirmButtonStyle = propsStyle.confirmButton || {};
  const gumConfigurationStyle = propsStyle.gumConfiguration || {};
  const audioConfigurationStyle = propsStyle.audioConfiguration || {};
  const videoConfigurationStyle = propsStyle.videoConfiguration || {};
  const confirmButtonClassName = classNames.confirmButton || styles.confirmButton;
  const gumConfigurationClassName = classNames.gumConfiguration || styles.gumConfigurationWrapper;
  const audioConfigurationClassName = classNames.audioConfiguration || styles.audioConfigurationWrapper;
  const videoConfigurationClassName = classNames.videoConfiguration || styles.videoConfigurationWrapper;

  return (
    <div
      style={gumConfigurationStyle}
      className={gumConfigurationClassName}
    >
      {!videoOnly && (
        <div
          style={audioConfigurationStyle}
          className={audioConfigurationClassName}
        >
          <MediaSourceSelector
            sources={audioSources}
            className={classNames.sourceSelect}
            propsStyle={propsStyle.sourceSelect}
            typeOfSource="audio"
            selectedSource={selectedAudioSource}
            includeScreen={false}
            onSourceSelect={onAudioSourceSelect}
          />
          <AudioContainer
            className={classNames.audioPreview}
            propsStyle={propsStyle.audioPreview}
            mediaStream={audioMediaStream}
          />
        </div>
      )}
      {!audioOnly && (
        <div
          style={videoConfigurationStyle}
          className={videoConfigurationClassName}
        >
          <MediaSourceSelector
            sources={videoSources}
            className={classNames.sourceSelect}
            propsStyle={propsStyle.sourceSelect}
            typeOfSource="video"
            selectedSource={selectedVideoSource}
            includeScreen={includeScreen}
            onSourceSelect={onVideoSourceSelect}
          />
          <VideoContainer
            className={classNames.videoPreview}
            propsStyle={propsStyle.videoPreview}
            mediaStream={videoMediaStream}
          />
        </div>
      )}
      <button
        style={confirmButtonStyle}
        className={confirmButtonClassName}
        onClick={confirmDevices}
        disabled={confirmButtonDisabled}
      >
        {confirmButtonText || 'Confirm Microphone & Camera Settings'}
      </button>
    </div>
  );
};

GUMConfigurationView.propTypes = {
  classNames: PropTypes.object.isRequired,
  propsStyle: PropTypes.object.isRequired,
  audioSources: PropTypes.array.isRequired,
  videoSources: PropTypes.array.isRequired,
  includeScreen: PropTypes.bool.isRequired,
  confirmDevices: PropTypes.func.isRequired,
  onVideoSourceSelect: PropTypes.func.isRequired,
  onAudioSourceSelect: PropTypes.func.isRequired,
  videoOnly: PropTypes.bool,
  audioOnly: PropTypes.bool,
  audioMediaStream: PropTypes.object,
  videoMediaStream: PropTypes.object,
  selectedAudioSource: PropTypes.string,
  selectedVideoSource: PropTypes.string,
  confirmButtonText: PropTypes.string,
  confirmButtonDisabled: PropTypes.bool
};

export default GUMConfigurationView;